<template>
  <div id="attachment">
    <div class="upload flex">
      <div class="upload-box cursor" @dragover.prevent @drop="onDropImage">
        <label for="files" class="drag-drop">
          {{ progress }}
        </label>
        <input
          type="file"
          id="files"
          ref="files"
          multiple
          accept="image/*"
          @change="handleFilesUpload"
        />
      </div>
      <label for="files" class="upload-icon cursor">
        <img src="@/assets/attachment.png" alt="attachment" />
      </label>
    </div>
    <div
      :class="[
        !files.length > 0 ? 'flex align-center justify-center' : '',
        'image-list'
      ]"
    >
      <p v-if="!files.length > 0" class="empty-box">
        Upload an attachment to appear here
      </p>
      <div class="image-preview" v-for="(file, key) in files" :key="key">
        <img class="preview" :ref="'image' + parseInt(key)" alt="vehicles" />
        <span
          v-if="files.length > 0"
          @click="removeFile(key)"
          class="mdi mdi-24px mdi-delete cursor"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      files: []
    };
  },
  methods: {
    onDropImage(e) {
      e.stopPropagation();
      e.preventDefault();
      const dt = e.dataTransfer.files;
      const uploadedFiles = dt[0];
      // Adds the uploaded file to the files array
      this.files.push(uploadedFiles);
      // Generate image previews for the uploaded files
      this.getImagePreviews();
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      // Adds the selected file to the files array
      for (let i = 0; i < uploadedFiles.length; i++) {
        if (this.files.length + 1 > 5) {
          break;
        }
        this.files.push(uploadedFiles[i]);
        this.$emit("files", uploadedFiles[i]);
      }
      // Generate image previews for the uploaded files
      this.getImagePreviews();
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        // ensure files is an image
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function() {
              this.$refs["image" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          // read the files for the file in through the reader
          reader.readAsDataURL(this.files[i]);
        }
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.$emit("files", this.files);
    }
  },
  computed: {
    ...mapGetters("auth", ["uploadProgress"]),
    ...mapGetters(["loading"]),
    progress() {
      const value = this.loading
        ? "Uploading..."
        : this.uploadProgress > 90 && this.loading <= 100
        ? "This may take a while"
        : !this.loading
        ? "Drag and Drop"
        : "Drag and Drop";
      return value;
    }
  }
};
</script>

<style scoped>
input[type="file"] {
  visibility: hidden;
}
#files::-webkit-file-upload-button {
  visibility: hidden;
}
.upload-box {
  position: relative;
  margin-bottom: 10px;
  background: var(--surface-2);
  border: 1px dashed var(--line-strong);
  box-sizing: border-box;
  border-radius: var(--radius-md);
  height: 80px;
  width: 80%;
  transition: border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
}
.upload-box:hover {
  border-color: var(--accent-600);
  background: var(--accent-050);
}
#attachment .upload .upload-icon {
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
  margin-left: 10px;
  transition: background var(--dur) var(--ease);
}
#attachment .upload .upload-icon:hover {
  background: var(--accent-050);
}
#attachment .upload label {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 22px;
  letter-spacing: 0.05em;
  color: var(--muted-soft);
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  margin-bottom: 15px;
  padding: 1rem;
}
.image-preview {
  position: relative;
  width: 140px;
  height: 140px;
}
.drag-drop {
  position: absolute;
  left: 0;
  right: 0;
  top: 27px;
}
.preview {
  width: 100%;
  height: 100%;
  border-radius: var(--radius-sm);
}
.image-list span {
  z-index: 2000;
  position: absolute;
  top: -8px;
  right: -10px;
  color: var(--danger);
}
.image-list span::before {
  font-size: 1.3rem !important;
}
.empty-box {
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 22px;
  letter-spacing: 0.05em;
  color: var(--muted-soft);
}
</style>
